const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDYwMCAxMDEwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiMxNDM3RkYiIGQ9Ik01OTUgODRxMCAxMy0xMCAyM2wtMzkzIDM5MyAzOTMgMzkzcTEwIDEwIDEwIDIzdC0xMCAyM2wtNTAgNTBxLTEwIDEwLTIzIDEwdC0yMy0xMGwtNDY2LTQ2NnEtMTAtMTAtMTAtMjN0MTAtMjNsNDY2LTQ2NnExMC0xMCAyMy0xMHQyMyAxMGw1MCA1MHExMCAxMCAxMCAyM3oiLz48L3N2Zz4K";
export {
  M as default
};
//# sourceMappingURL=back_blue-edbc8d74.mjs.map
